//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchResultsText from "./SearchResultsText.vue";

export default {
    components: {
        SearchResultsText
    },
    props: {
        searchPlaceholder: {
            type: String,
            default: "Enter search terms"
        },
        searchButtonText: {
            type: String,
            default: "Submit your search"
        }
    },
    methods: {
        submitSearch: function () {
            this.$emit('submitSearch', this.query);
        },
        clearSearch: function () {
            this.query = "";
            this.$emit('submitSearch', this.query);
        }
    },
    watch: {
        currentQuery() {
            this.query = this.$store.state.searchQuery.searchTerm;
        }
    },
    mounted: function () {
        this.query = this.currentQuery.searchTerm;
    },
    data: function () {
        return {
            query: ""
        }
    },
    computed: {
        settings: function () {
            return this.$store.state.settings;
        },

        currentResultStart: function () {
            if (this.results.currentPage == 0) {
                return 1;
            } else {
                return (this.results.currentPage * this.results.pageSize) + 1;
            }

        },
        currentResultsEnd: function () {
            if (this.results.currentPage == 0) {
                if (this.results.totalResultCount <= this.results.pageSize) {
                    return this.results.totalResultCount;
                } else {
                    return this.results.pageSize;
                }
            } else {
                var max = ((this.results.currentPage + 1) * this.results.pageSize) + 1;
                if (max > this.results.totalResultCount) {
                    return this.results.totalResultCount;
                } else {
                    return max;
                }
            }
        },
        results: function () {
            return this.$store.state.results;
        },
        currentQuery: function () {
            return this.$store.state.searchQuery;
        }
    }
}
